<div class="one-time-option">
  <app-option-checkbox
    [checked]="isOneTimeView"
    (checkedChange)="onChange($event)"
    title="One-time access"
    subtitle="Permanently deleted after first open"
  ></app-option-checkbox>
</div>
